import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import PaymentState, {PaymentList} from './states'
import CenterState, {CenterList} from '../center/states'
import _ from 'lodash'
import { State } from '@/store/store'
import axios from 'axios'
import httpRequest from '../../../../services/HttpRequestServiceWithToken'

const actions: ActionTree<PaymentState, State> = {
  async getPaymentList(
    { commit, dispatch, state }: ActionContext<PaymentState, State>,
    options: object,
  ): Promise<void> {
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'payment', options, async (res: PaymentList) => {
        const resultPayment = res.result
        // const centerIds = resultPayment.map((item) => item.centerId)
        // const centerIdsUnique = centerIds.filter(function(item, id) {
        //   return centerIds.indexOf(item) === id
        // })
        if (!_.isEmpty(resultPayment)) {
            // const condition = {
            //   _id: [{
            //     condition: 'contains',
            //     value: centerIdsUnique,
            //   }],
            // }
            // await httpRequest
            //   .getByLevel(process.env.VUE_APP_API_URL + '/v1' , 'center', {headers: {
            //     filter: Buffer.from(JSON.stringify(condition)).toString('base64'),
            //   }}, (resCenter: CenterList) => {
            //     const resultCenter = resCenter.result
            //     resultPayment.forEach((data) => {
            //       const centerName = resultCenter.find( ({ _id }) => _id === data.centerId)
            //       data.centerName = '-'
            //       if (typeof centerName.name !== 'undefined') {
            //           data.centerName = centerName.name
            //       }
            //     })
            // })
        }
        res.result = resultPayment
        commit(mutationType.GET_LISTS, res)
      })
  },
}

export default actions
